import React from 'react'
import Axios from 'axios'
import ReactSelect from 'components/common/ReactSelect'
import { API } from 'api/APIClient'
import AppComponent from 'components/common/AppComponent'
import ModalProgress from 'components/common/ModalProgress'
import moment from 'moment'
import DateHelper from 'utils/DateHelper'
import { NotificationManager } from 'react-notifications'

export default class ConnectorForm extends AppComponent {

    static defaultProps = {
        item: {}
    }

    static normalizeItem(item, context) {
        const normalized = Object.assign({
            createdAt: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            organisationID: context.organisation.id,
            name: "",
            connectorTypeID: null,
            data: {},
            active: 1
        }, item || {});

        if (!normalized.connectorTypeID && normalized.typeID) {
            normalized.connectorTypeID = normalized.typeID;
        }
        if (!normalized.connectorTypeID && normalized.type && normalized.type.id) {
            normalized.connectorTypeID = normalized.type.id;
        }

        if (!normalized.name && normalized.connectorName) {
            normalized.name = normalized.connectorName;
        }

        if (typeof normalized.data === "string") {
            try {
                normalized.data = JSON.parse(normalized.data);
            }
            catch (e) {
                normalized.data = {};
            }
        }
        else if ((!normalized.data || Object.keys(normalized.data).length === 0) && normalized.connectorData) {
            if (typeof normalized.connectorData === "string") {
                try {
                    normalized.data = JSON.parse(normalized.connectorData);
                }
                catch (e) {
                    normalized.data = {};
                }
            }
            else if (typeof normalized.connectorData === "object") {
                normalized.data = Object.assign({}, normalized.connectorData);
            }
        }

        if (!normalized.data || typeof normalized.data !== "object") {
            normalized.data = {};
        }

        return normalized;
    }

    constructor(props, context) {
        super(props);

        const normalizedItem = ConnectorForm.normalizeItem(props.item, context);

        this.state = {
            item: normalizedItem,
            organisationOptions: [
                normalizedItem.organisationID ? {value: normalizedItem.organisationID, label: normalizedItem.organisationName || context.organisation.name} : {value: context.organisation.id, label: context.organisation.name}
            ],
            connectorTypes: [],
            connectorTypeOptions: [],
            selectedConnectorTypeFields: [],
            validated: false,
            errors: {},
            touched: {},
            isUploading: false
        };
    }

    componentDidMount() {
        this.validate();

        if (this.context.permissions.connector.allOrgs) {
            this.getOrganisationOptions();
        }

        this.getConnectorTypes();
    }

    getOrganisationOptions = () => {
        Axios
            .get(API.organisation.getOrganisations, {
                props: {
                    appUsersOnly: 1
                }
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        organisationOptions: res.data.data.organisations.map((item) => { return {value: item.id.toString(), label: item.name} })
                    })
                }
            })
    }

    getConnectorTypes = () => {
        Axios
            .get(API.connector.getConnectorTypes)
            .then((res) => {
                if (res.data.success) {
                    const data = res.data.data;
                    const connectorTypes =
                        (data && data.connectorTypes) ||
                        (data && data.types) ||
                        (data && data.connectors) ||
                        (Array.isArray(data) ? data : []);
                    const connectorTypeOptions = connectorTypes.map((connectorType) => {
                        return {
                            value: connectorType.id,
                            label: connectorType.name
                        }
                    });

                    this.setState({
                        connectorTypes,
                        connectorTypeOptions
                    }, () => {
                        this.syncConnectorTypeFields();
                    })
                }
            })
    }

    getSelectedConnectorType = () => {
        return this.state.connectorTypes.find((connectorType) => {
            return connectorType.id.toString() === (this.state.item.connectorTypeID || '').toString();
        }) || null;
    }

    syncConnectorTypeFields = () => {
        const selectedType = this.getSelectedConnectorType();
        const selectedConnectorTypeFields = selectedType && selectedType.fields ? selectedType.fields : [];

        this.setState((prevState) => {
            const item = Object.assign({}, prevState.item);
            const nextData = Object.assign({}, item.data || {});

            selectedConnectorTypeFields.forEach((field) => {
                if (!nextData.hasOwnProperty(field.key)) {
                    nextData[field.key] = "";
                }
            });

            Object.keys(nextData).forEach((dataKey) => {
                if (!selectedConnectorTypeFields.find((field) => field.key === dataKey)) {
                    delete nextData[dataKey];
                }
            });

            item.data = nextData;

            return {
                item,
                selectedConnectorTypeFields
            }
        }, () => {
            this.validate();
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (!this.state.isUploading) {
            this.setState({
                isUploading: true
            }, () => {
                const payload = {
                    id: this.state.item.id,
                    organisationID: this.state.item.organisationID,
                    name: this.state.item.name,
                    typeID: this.state.item.connectorTypeID,
                    data: this.state.item.data,
                    active: this.state.item.active
                };

                Axios
                    .post(API.connector.submitConnector, payload)
                    .then((res) => {
                        if (res.data.success) {
                            NotificationManager.success(this.state.item.id ? "Connector updated" : "Connector created");
                            this.props.onSubmitted(res.data.data.item);
                        }
                        else if (res.data.error) {
                            let errors = this.state.errors;
                            errors.genericError = res.data.error.desc;
                            this.setState({
                                errors: errors
                            });
                        }

                        this.setState({
                            isUploading: false
                        });
                    })
                    .catch((error) => {
                        let errors = this.state.errors;
                        errors.genericError = error.response && error.response.data && error.response.data.error ? error.response.data.error.desc : "Something went wrong";
                        this.setState({
                            errors,
                            isUploading: false
                        })
                    })
            })
        }
    }

    handleBlur = (event) => {
        const target = event.target;
        const name = target.name;

        let touched = this.state.touched;
        touched[name] = true;

        this.setState({
            touched: touched
        }, () => {
            this.validate()
        })
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        let item = Object.assign({}, this.state.item);

        if (name.indexOf("data.") === 0) {
            const dataKey = name.replace("data.", "");
            item.data = Object.assign({}, item.data, {
                [dataKey]: value
            });
        }
        else {
            item[name] = value;

            if (name === "connectorTypeID") {
                item.data = {};
            }
        }

        this.setState({
            item: item
        }, () => {
            if (name === "connectorTypeID") {
                this.syncConnectorTypeFields();
            }
            else {
                this.validate();
            }
        });
    }

    validate = () => {

        let validated = true;
        let errors = {};

        const item = this.state.item;
        const touched = this.state.touched;

        if (!item.organisationID) {
            if (touched.organisationID) {
                errors.organisationID = "Organisation is required";
            }
            validated = false;
        }

        if (!item.connectorTypeID) {
            if (touched.connectorTypeID) {
                errors.connectorTypeID = "Connector type is required";
            }
            validated = false;
        }

        if (!item.name || !item.name.trim()) {
            if (touched.name) {
                errors.name = "Name is required";
            }
            validated = false;
        }

        this.state.selectedConnectorTypeFields.forEach((field) => {
            const fieldErrorKey = `data.${field.key}`;
            const fieldValue = item.data && item.data[field.key] !== undefined && item.data[field.key] !== null ? item.data[field.key].toString() : "";

            if (field.isRequired && !fieldValue.trim()) {
                if (touched[fieldErrorKey]) {
                    errors[fieldErrorKey] = `${field.name} is required`;
                }
                validated = false;
            }

            if (fieldValue && field.type === "int" && Number.isNaN(Number(fieldValue))) {
                if (touched[fieldErrorKey]) {
                    errors[fieldErrorKey] = `${field.name} must be a number`;
                }
                validated = false;
            }
        });

        this.setState({
            validated: validated,
            errors: errors
        });
    }

    render() {
        const isEdit = !!this.state.item.id;

        return (
            <React.Fragment>
                <ModalProgress show={this.state.isUploading} />
                <div className="modal-head">
                    <h3>{isEdit ? "Edit Connector" : "New Connector"}</h3>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className="modal-body">
                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="createdAt" className="text-right middle">Created At</label>
                            </div>
                            <div className="large-9 small-9 cell">
                                <input name="createdAt" type="text" value={moment(DateHelper.convertToLocalDateTime(this.state.item.createdAt), "YYYY-MM-DD HH:mm:ss").format("LLLL")} disabled={true} />
                            </div>
                        </div>

                        {!isEdit && this.context.permissions.connector.allOrgs ?
                            <div className="grid-x grid-padding-x">
                                <div className="small-3 cell">
                                    <label htmlFor="organisationID" className="text-right middle">* Organisation</label>
                                </div>
                                <div className={"small-9 cell " + (this.state.errors.organisationID && "error")}>
                                    <ReactSelect
                                        name="organisationID"
                                        className="react-select"
                                        onChange={this.handleChange}
                                        value={this.state.item.organisationID}
                                        options={this.state.organisationOptions}
                                        onBlur={this.handleBlur}
                                    />
                                    <small className="error">{this.state.errors.organisationID}</small>
                                </div>
                            </div>
                            :
                            <div className="grid-x grid-padding-x">
                                <div className="small-3 cell">
                                    <label htmlFor="organisationName" className="text-right middle">Organisation</label>
                                </div>
                                <div className="small-9 cell">
                                    <input type="text" name="organisationName" value={this.state.item.organisationName || this.context.organisation.name} disabled/>
                                </div>
                            </div>
                        }

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="name" className="text-right middle">* Name</label>
                            </div>
                            <div className={"small-9 cell " + (this.state.errors.name && "error")}>
                                <input
                                    type="text"
                                    name="name"
                                    value={this.state.item.name || ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleBlur}
                                    required
                                />
                                <small className="error">{this.state.errors.name}</small>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="connectorTypeID" className="text-right middle">* Connector Type</label>
                            </div>
                            <div className={"small-9 cell " + (this.state.errors.connectorTypeID && "error")}>
                                <ReactSelect
                                    name="connectorTypeID"
                                    className="react-select"
                                    onChange={this.handleChange}
                                    value={this.state.item.connectorTypeID}
                                    options={this.state.connectorTypeOptions}
                                    onBlur={this.handleBlur}
                                />
                                <small className="error">{this.state.errors.connectorTypeID}</small>
                            </div>
                        </div>

                        {this.state.selectedConnectorTypeFields.map((field) => {
                            const inputName = `data.${field.key}`;
                            const inputType = field.type === "int" ? "number" : "text";

                            return (
                                <div className="grid-x grid-padding-x" key={field.key}>
                                    <div className="small-3 cell">
                                        <label htmlFor={inputName} className="text-right middle">{field.isRequired ? "* " : ""}{field.name}</label>
                                    </div>
                                    <div className={"small-9 cell " + (this.state.errors[inputName] && "error")}>
                                        <input
                                            type={inputType}
                                            name={inputName}
                                            value={(this.state.item.data && this.state.item.data[field.key] !== undefined && this.state.item.data[field.key] !== null) ? this.state.item.data[field.key] : ""}
                                            onChange={this.handleChange}
                                            onBlur={this.handleBlur}
                                            required={!!field.isRequired}
                                        />
                                        {field.description && <small className="field-info">{field.description}</small>}
                                        <small className="error">{this.state.errors[inputName]}</small>
                                    </div>
                                </div>
                            );
                        })}

                        <div className="form-error-msg grid-x grid-padding-x" style={{display: this.state.errors.genericError ? "block" : "none"}}>
                            <div className="cell small-12">
                                <span>{this.state.errors.genericError}</span>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="grid-x grid-padding-x">
                            <div className="small-12 cell">
                                <div className="btn-wrap">
                                    <button className="button secondary" type="button" onClick={this.props.onCancel}>
                                        Cancel
                                    </button>
                                    <button className="button success" type="submit" disabled={!this.state.validated}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </React.Fragment>
        );
    }
}
